import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';

const contactInfo = [
  {
    icon: 'fa-map-marker-alt', color: '#0066FF', bg: '#e8f0ff',
    title: 'Our Office',
    href: 'https://maps.google.com/?q=D-184+Sector-63+Noida+UP+201301',
    text: 'D-184, Sector-63, Noida, UP - 201301',
  },
  {
    icon: 'fa-phone-alt', color: '#00C896', bg: '#e6fff6',
    title: 'Call Us',
    href: 'tel:+919718094931',
    text: '+91 97180 94931',
  },
  {
    icon: 'fa-envelope', color: '#f59e0b', bg: '#fff8e6',
    title: 'Email Us',
    href: 'mailto:onexvorabusinesssolutions@gmail.com',
    text: 'onexvorabusinesssolutions@gmail.com',
  },
  {
    icon: 'fa-clock', color: '#8b5cf6', bg: '#f3eeff',
    title: 'Working Hours',
    href: null,
    text: 'Mon - Sat: 10am - 6pm',
  },
];

const faqs = [
  { q: 'How do I post a job?', a: 'Create an employer account, go to your dashboard and click Post a Job. Fill in the details and publish.' },
  { q: 'Is JobEntry free for job seekers?', a: 'Yes! Creating a profile and applying to jobs is completely free for all job seekers.' },
  { q: 'How long does it take to get a response?', a: 'Our support team typically responds within 24 hours on business days.' },
  { q: 'Can I edit my job listing after posting?', a: 'Yes, you can edit or delete your job listing anytime from your employer dashboard.' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', type: '', message: '' });
  const [sent, setSent] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch('http://localhost:5001/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to send');
      setSent(true);
      setForm({ name: '', email: '', subject: '', type: '', message: '' });
      setTimeout(() => setSent(false), 4000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <PageHeader title="Contact Us" breadcrumb="Contact" />

      {/* Info Cards */}
      <section className="section-pad pb-0">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Get In Touch</span>
            <h2 className="section-title">We'd Love to Hear From You</h2>
            <p className="section-sub">Have a question or need help? Reach out and our team will get back to you shortly.</p>
          </div>
          <div className="contact-info-grid">
            {contactInfo.map((c, i) => (
              <div className="contact-info-card" key={i}>
                <div className="contact-info-icon" style={{ background: c.bg, color: c.color }}>
                  <i className={`fa ${c.icon}`}></i>
                </div>
                <h6>{c.title}</h6>
                {c.href
                  ? <a href={c.href} target="_blank" rel="noreferrer" className="contact-info-link">{c.text}</a>
                  : <p>{c.text}</p>
                }
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="section-pad">
        <div className="container">
          <div className="contact-main-grid">

            <div className="contact-form-card">
              <div className="contact-form-header">
                <h3>Send Us a Message</h3>
                <p>Fill out the form and we'll get back to you within 24 hours.</p>
              </div>

              {sent && (
                <div className="contact-success">
                  <i className="fa fa-check-circle me-2"></i>
                  Message sent successfully! We'll get back to you soon.
                </div>
              )}
              {error && (
                <div className="auth-alert error">
                  <i className="fa fa-exclamation-circle me-2"></i>{error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="contact-form-row">
                  <div className="contact-field">
                    <label>Full Name</label>
                    <div className="contact-input-wrap">
                      <i className="fa fa-user"></i>
                      <input type="text" placeholder="John Doe"
                        value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                    </div>
                  </div>
                  <div className="contact-field">
                    <label>Email Address</label>
                    <div className="contact-input-wrap">
                      <i className="fa fa-envelope"></i>
                      <input type="email" placeholder="you@example.com"
                        value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
                    </div>
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-field">
                    <label>Subject</label>
                    <div className="contact-input-wrap">
                      <i className="fa fa-tag"></i>
                      <input type="text" placeholder="How can we help?"
                        value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} required />
                    </div>
                  </div>
                  <div className="contact-field">
                    <label>Inquiry Type</label>
                    <div className="contact-input-wrap">
                      <i className="fa fa-list"></i>
                      <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} required>
                        <option value="">Select type</option>
                        <option>General Inquiry</option>
                        <option>Job Seeker Support</option>
                        <option>Employer Support</option>
                        <option>Technical Issue</option>
                        <option>Partnership</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="contact-field">
                  <label>Message</label>
                  <div className="contact-input-wrap textarea">
                    <i className="fa fa-comment-alt"></i>
                    <textarea rows="5" placeholder="Write your message here..."
                      value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} required></textarea>
                  </div>
                </div>

                <button type="submit" className="contact-submit-btn">
                  <i className="fa fa-paper-plane me-2"></i> Send Message
                </button>
              </form>
            </div>

            <div className="contact-side">
              <div className="contact-map-card">
                <div className="contact-map-placeholder">
                  <div className="map-pin-wrap">
                    <div className="map-pin"><i className="fa fa-map-marker-alt"></i></div>
                    <div className="map-pin-pulse"></div>
                  </div>
                  <p>D-184, Sector-63, Noida, UP - 201301</p>
                  <a href="https://maps.google.com/?q=D-184+Sector-63+Noida+UP+201301" target="_blank" rel="noreferrer" className="map-directions-btn">
                    <i className="fa fa-directions me-2"></i> Get Directions
                  </a>
                </div>
              </div>

              <div className="contact-social-card">
                <h6>Follow Us</h6>
                <div className="contact-socials">
                  {[
                    { icon: 'fab fa-linkedin-in', label: 'LinkedIn',  color: '#0077b5', href: '#' },
                    { icon: 'fab fa-twitter',     label: 'Twitter',   color: '#1da1f2', href: '#' },
                    { icon: 'fab fa-facebook-f',  label: 'Facebook',  color: '#1877f2', href: '#' },
                    { icon: 'fab fa-instagram',   label: 'Instagram', color: '#e1306c', href: '#' },
                  ].map((s, i) => (
                    <a key={i} href={s.href} className="contact-social-item">
                      <div className="contact-social-icon" style={{ background: s.color + '18', color: s.color }}>
                        <i className={s.icon}></i>
                      </div>
                      <span>{s.label}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">FAQ</span>
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-sub">Quick answers to the most common questions</p>
          </div>
          <div className="contact-faq-grid">
            {faqs.map((f, i) => (
              <div key={i} className={`contact-faq-item ${openFaq === i ? 'open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <div className="faq-question">
                  <span>{f.q}</span>
                  <i className={`fa fa-chevron-${openFaq === i ? 'up' : 'down'}`}></i>
                </div>
                {openFaq === i && <p className="faq-answer">{f.a}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Ready to Find Your Dream Job?</h2>
              <p>Join 120,000+ professionals already using JobEntry.</p>
            </div>
            <div className="cta-right">
              <a href="/login" className="cta-btn-white">Get Started Free</a>
              <a href="/job-list" className="cta-btn-outline">Browse Jobs</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
